module.exports = __webpack_public_path__ + "img/service-point-received.62f2c0ea.svg";